const langtrans={
      gyjypt:["关于救援平台使用的说明","About use of the assistance service platform"],
      pttzzs:["平台正式上线，各位服务商在使用过程中有任何问题，可随时联系江泰运营指挥中心，电话：","The platform has officially gone online. Please contact Jiang Tai Command Center any time at +86 10 68180898 if you have any questions in regard to its use."],
      yx:["，邮箱：",",Email:"],
      gnczx:["功能查询","Checking its functionality"],
      ywcajc:["已完成案件查询","Checking of completed cases"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/commonPage/js/footer.vue.trans.js